module.exports = "/dist/img/giftshopper_sample1.2d657024.jpg";